import { Params } from '@angular/router';
import isEmpty from 'lodash.isempty';
import { AttributeOption } from '~shared/models';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';

export class AttributeFilterHandler {

  private static _instance: AttributeFilterHandler;
  public static get instance(): AttributeFilterHandler {
    if (!AttributeFilterHandler._instance) {
      AttributeFilterHandler._instance = new AttributeFilterHandler();
    }

    return AttributeFilterHandler._instance;
  }

  protected queryParams: Params;

  updateQueryParams(params: Params): void {
    this.queryParams = params;
  }


  apply(attrs: { [key: string]: string }, attributeName?: string): FilterHandlerParams {
    const queryParams = this.queryParams || {};
    const filter = queryParams.filter || {};
    const { options = {}, ...rest } = filter;
    const mergedOptions = {
      ...options,
      ...attrs,
      [attributeName]: attrs && attrs[attributeName]
    };

    return { params: { filter: { options: mergedOptions, ...rest } }, config: { resetPaging: true } };
  }

  remove(attribute: AttributeOption, attributeId: string): FilterHandlerParams {
    const { filter: { options: options } } = this.queryParams || {};

    const nextAttributeTags = Object.keys(options).reduce((acc, urlFilterKey) => {
      const nextAttributeOptions = options[`${urlFilterKey}`]
        .filter((attrId: string) => attrId.toString() !== attribute.value);

      if (!isEmpty(nextAttributeOptions)) {
        const transformedAttrOptions =
          nextAttributeOptions.reduce((options: { [key: string]: string }, attr: string, index: number) => ({
            ...options,
            [`${index}`]: attr,
          }), {});
        return { ...acc, [`${urlFilterKey}`]: transformedAttrOptions };
      }

      return { ...acc };
    }, {});

    return this.apply(nextAttributeTags, attributeId);
  }

  reset(attrId: string): FilterHandlerParams {
    const { filter: { options: {...options} } } = this.queryParams || {};
    options[attrId] = null;
    return this.apply(options, attrId);
  }
}
